import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-vendor-toggle-popup',
  templateUrl: './vendor-toggle-popup.component.html',
  styleUrls: ['./vendor-toggle-popup.component.scss']
})
export class VendorTogglePopupComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  constructor( @Inject(MAT_DIALOG_DATA)
  public data,
  public dialogRef: MatDialogRef<VendorTogglePopupComponent>,
  ) { }

  ngOnInit(): void {
    this.data = this.data.data;
    this.data.filter((ele)=>{
      if(ele.imageUrl==null){
        ele.imageUrl='assets/images/No_image.png'
      }
    })
  }

  action() {
    this.dialogRef.close()
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}